import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

export interface DownloadPageData {
  title: string;
  link: string;
}

@Component({
  selector: 'fcp-download-page',
  templateUrl: './download-page.component.html',
  styleUrls: ['./download-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadPageComponent {

  @Input() public links: Array<DownloadPageData>;

  public config = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };

  public download(url: string) {
    if (url) {
      window.open(url);
    }
  }

}
